import { useRef, useState } from "react";

import {
  Breadcrumb,
  Button,
  Col,
  Divider,
  Form,
  Layout,
  message,
  Row,
  Space,
} from "antd";

import { PrinterOutlined, TableOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import ReactToPrint from "react-to-print";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import { onCustomerSearch } from "../../utils/utilities";
import { formItemLayout, smallFormItemLayout } from "./../../utils/Layouts";

const { Content } = Layout;

const transaction = "inventory-adjustments";
const url = `/api/${transaction}/`;
const title = "Inventory Adjustments";

const initialValues = {
  period_covered: [moment(), moment()],
};
export default function InventoryAdjustmentReport() {
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const auth = useSelector((state) => state.auth);
  const [state, setState] = useState(initialValues);
  const [options, setOptions] = useState({
    customers: [],
  });
  const [loading, setLoading] = useState({
    search: false,
    download: false,
  });

  const report = useRef(null);

  const getReport = useCallback(
    ({ period_covered, account, is_excel = false }) => {
      if (period_covered) {
        const form_data = {
          period_covered,
          account,
          is_excel,
        };

        setLoading((prevState) => ({
          ...prevState,
          search: !is_excel,
          download: is_excel,
        }));

        axios
          .post(`${url}history`, form_data)
          .then((response) => {
            loading();
            if (response.data) {
              if (is_excel) {
                setLoading((prevState) => ({
                  ...prevState,
                  download: false,
                }));
                return window.open(`/public/reports/${response.data.filename}`);
              }

              setRecords(response.data);
              setState((prevState) => ({
                ...prevState,
                total: response.data.total,
              }));
              setLoading((prevState) => ({
                ...prevState,
                search: false,
              }));
            }
          })
          .catch((err) => {
            message.error("There was an error processing your request");
            setLoading((prevState) => ({
              ...prevState,
              search: false,
              download: false,
            }));
          });
      } else {
        message.error("Please select period covered");
      }
    },
    []
  );

  return (
    <Content className="content-padding">
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Reports</Breadcrumb.Item>
            <Breadcrumb.Item className="text-color-yellow">
              {title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <div
        style={{
          background: "#fff",
          padding: 24,
          minHeight: 280,
          borderRadius: 10,
        }}
      >
        <span className="module-title">{title}</span>
        <Divider />
        <Row>
          <Col span={12}>
            <RangeDatePickerFieldGroup
              label="Period Covered"
              name="period_covered"
              value={state.period_covered}
              onChange={(dates) =>
                setState((prevState) => ({
                  ...prevState,
                  period_covered: dates,
                }))
              }
              error={errors.period_covered}
              formItemLayout={smallFormItemLayout}
            />
          </Col>
          <Col span={12}>
            <SelectFieldGroup
              label="Account"
              value={state.account?.name}
              onSearch={(value) =>
                onCustomerSearch({ value, options, setOptions })
              }
              onChange={(index) => {
                const account = options.accounts[index];
                setState((prevState) => ({
                  ...prevState,
                  account,
                }));
              }}
              error={errors.account}
              formItemLayout={formItemLayout}
              data={options.accounts}
              column="name"
            />
          </Col>
        </Row>

        <Row>
          <Col span={12} offset={4}>
            <Form.Item className="field is-grouped">
              <Space>
                <Button
                  onClick={() => {
                    getReport({
                      ...state,
                    });
                  }}
                  loading={loading.search}
                  disabled={loading.search}
                >
                  Search
                </Button>
                <Button
                  icon={<TableOutlined />}
                  onClick={() => {
                    getReport({
                      ...state,
                      is_excel: true,
                    });
                  }}
                  loading={loading.download}
                  disabled={loading.download}
                >
                  Download to Excel
                </Button>
                <ReactToPrint
                  trigger={() => (
                    <Button type="primary" icon={<PrinterOutlined />}>
                      Print
                    </Button>
                  )}
                  bodyClass="print"
                  content={() => report.current}
                />
              </Space>
            </Form.Item>
          </Col>
        </Row>
        <div ref={report}>
          <div>
            <div className="has-text-weight-bold">{title}</div>
            <div>
              Period Covered: {state.period_covered?.[0]?.format("MM/DD/YYYY")}{" "}
              to {state.period_covered?.[1]?.format("MM/DD/YYYY")}
            </div>
            <div>
              {state.branch?.company?.name || ""} - {state.branch?.name || ""}
            </div>
          </div>
          <table className="full-width sales-report-table m-t-1">
            <thead>
              <tr>
                <th className="has-text-centered">Date</th>
                <th className="has-text-centered">ADJ #</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {records.map((record) => (
                <tr>
                  <td className="has-text-centered">
                    {moment(record.date).format("MM/DD/YYYY")}
                  </td>
                  <td className="has-text-centered">{record.adj_no}</td>
                  <td>{record.remarks}</td>
                </tr>
              ))}
            </tbody>
            {/* <tfoot
              className="has-text-weight-bold"
              style={{ borderTop: "2px solid #333" }}
            >
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tfoot> */}
          </table>
        </div>
      </div>
    </Content>
  );
}
